const billing = {
  billing: 'Billing',
  billingChargesSoFar: 'Charges so far',
  billingChargesSoFarDetail: 'Connector runs already billed this month, at $0.01 each.',
  billingMonthEstimate: 'Estimated this month',
  billingMonthEstimateDetail: 'One run per active connector each day, at $0.01. Finished runs this month are included.',
  creditCardCvc: 'CVC',
  creditCardExpiration: 'Expiration Date',
  creditCardName: 'Cardholder Name',
  creditCardNumber: 'Credit Card Number',
  pay: 'Pay',
  payments: 'Payments',
  setUpBilling: 'Set up billing',
};

export default billing;
